module.exports = __webpack_public_path__ + "static/media/falguni_patil.4e707b0c.jpg";